/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const SelectIcon = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2554 6.43614C10.0044 6.25345 9.6693 6.23578 9.40034 6.39104C9.13147 6.5463 8.9792 6.84534 9.01189 7.15413L9.82581 14.8496C9.8607 15.1794 10.0988 15.4517 10.4211 15.5303C10.7433 15.6089 11.0801 15.4767 11.2628 15.1998L12.9824 12.5954L16.0978 12.4084C16.4289 12.3886 16.7118 12.1629 16.8048 11.8446C16.8979 11.5263 16.7812 11.1838 16.5129 10.9887L10.2554 6.43614ZM11.8875 11.4017L11.1581 12.5064L10.7605 8.74693L13.8176 10.971L12.4961 11.0503C12.2493 11.0651 12.0238 11.1953 11.8875 11.4017Z"
        fill="#F6FAFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.785714 0C0.35178 0 0 0.35178 0 0.785714V3.92857C0 4.36251 0.35178 4.71429 0.785714 4.71429H1.57143V17.2857H0.785714C0.35178 17.2857 0 17.6375 0 18.0714V21.2143C0 21.6482 0.35178 22 0.785714 22H3.92857C4.36251 22 4.71429 21.6482 4.71429 21.2143V20.4286H17.2857V21.2143C17.2857 21.6482 17.6375 22 18.0714 22H21.2143C21.6482 22 22 21.6482 22 21.2143V18.0714C22 17.6375 21.6482 17.2857 21.2143 17.2857H20.4286V4.71429H21.2143C21.6482 4.71429 22 4.36251 22 3.92857V0.785714C22 0.35178 21.6482 0 21.2143 0H18.0714C17.6375 0 17.2857 0.35178 17.2857 0.785714V1.57143H4.71429V0.785714C4.71429 0.35178 4.36251 0 3.92857 0H0.785714ZM17.2857 18.0714V18.8571H4.71429V18.0714C4.71429 17.6375 4.36251 17.2857 3.92857 17.2857H3.14286V4.71429H3.92857C4.36251 4.71429 4.71429 4.36251 4.71429 3.92857V3.14286H17.2857V3.92857C17.2857 4.36251 17.6375 4.71429 18.0714 4.71429H18.8571V17.2857H18.0714C17.6375 17.2857 17.2857 17.6375 17.2857 18.0714ZM1.57143 3.14286V1.57143H3.14286V3.14286H1.57143ZM1.57143 20.4286V18.8571H3.14286V20.4286H1.57143ZM18.8571 1.57143V3.14286H20.4286V1.57143H18.8571ZM18.8571 18.8571V20.4286H20.4286V18.8571H18.8571Z"
        fill="#F6FAFD"
      />
    </svg>
  )
}
